import { PaginatedListDto } from "@server/dto/paginated-list.dto";
import { ActivityLog } from "@server/entities/project/activity-log.entity";

import { useStickySWR } from "../helpers";

export const getLogs = () =>
  useStickySWR<PaginatedListDto<ActivityLog>>(`/project/logs`);
